export const DUMMY_COMMENTS = [
  {
    id: 'dummy-1',
    nickname: 'ニックネーム1',
    content:
      'コメントのダミーテキストです。会員登録すると実際のコメントを閲覧できます。',
  },
  {
    id: 'dummy-2',
    nickname: 'ニックネーム2',
    content:
      'これはダミーのコメントです。実際のコメントは会員登録後にご覧いただけます。',
  },
  {
    id: 'dummy-3',
    nickname: 'ニックネーム3',
    content:
      'サンプルコメントテキストです。会員登録・ログインでコメントを閲覧できます。',
  },
] as const;
